import React from "react";
import { GramStoriesPostProps } from "./TheGramStoriesAppInterfaces";
import StoriesAIOverlay from "./Stories-AI.webp";

type GramStoriesPostPropss = {
  post: GramStoriesPostProps;
};

const GramStoriesPost: React.FC<GramStoriesPostPropss> = ({ post }) => {
  // Parse date from the post Date field (format: "24 April 2025, 11:47 AM")
  const parseDate = (dateString: string) => {
    // Extract just the date part and time part
    const [datePart, timePart] = dateString.split(", ");
    return {
      date: datePart,
      time: timePart,
    };
  };

  const { date, time } = parseDate(post.Date);

  return (
    <div className="gramstories-post-container">
      {/* Background Image */}
      <div className="gramstories-post-image-wrapper">
        <img src={post.Image} alt="Post" className="gramstories-post-image" />
      </div>

      {/* Overlay Content */}
      <div className="gramstories-overlay">
        {/* Top Bar */}
        <div className="gramstories-top-bar">
          <div className="gramstories-date">{date}</div>
          <div className="gramstories-time">{time}</div>
        </div>

        {/* Profile Section */}
        <div className="gramstories-profile-section">
          <div className="gramstories-profile-pic-container">
            <img
              src={post.Profile.image}
              alt="Profile"
              className="gramstories-profile-pic"
            />
          </div>
          <div className="gramstories-username">{post.Profile.name}</div>
        </div>

        {/* Stories AI Overlay */}
        <img
          src={StoriesAIOverlay}
          alt="Stories AI Overlay"
          className="gramstories-ai-overlay"
        />
      </div>
    </div>
  );
};

export default GramStoriesPost;
